module.exports = __webpack_public_path__ + "img/poslovni.59379a2e.svg";